<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{task}} Tote Price Matrix {{task === 'Edit' ? ' (ID: ' + data.pmInputData?.Id + ')' : ''}}
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="totePmForm" class="form-grid">
    <div class="form-grid-row">
      <!-- Disposal Site (Multi-Select, Required) -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('disposalSiteNames')" style=" width: 100%; margin-top: 15px;">
        <mat-label>Disposal Site</mat-label>
        <mat-select formControlName="disposalSite" multiple>
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #siteSearchInput matInput placeholder="Search Customer..." (input)="filterSites($event)"
              class="mat-select-search-input" aria-label="Search Customer" (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option *ngFor="let site of filtereddisposalSites()" [value]="site.sid">{{ site.siteName }}</mat-option>
        </mat-select>
        <mat-error *ngIf="totePmForm.get('disposalSite')?.hasError('required')">

        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Effective Start Date and end date -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('effective_StartDate')">
        <mat-label>Effective Start Date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="effectiveStartDate"
          (keydown)="onKeydown($event)" (blur)="dateformat($event)">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
        <mat-error *ngIf="totePmForm.get('effectiveStartDate')?.hasError('required')">

        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('effective_EndDate')">
        <mat-label>Effective End Date</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="effectiveEndDate" (keydown)="onKeydown($event)"
          (blur)="dateformat($event)">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Monthly Charges and additional pickup fee -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('monthlyCharges')">
        <mat-label>Monthly Charges</mat-label>
        <input matInput type="text" formControlName="monthlyCharges" placeholder="Enter Monthly Charges"
          (input)="roundOff($event, 9999, 4, 0, 'monthlyCharges')">
        <mat-error *ngIf="totePmForm.get('monthlyCharges')?.hasError('required')">

        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('extraPickup')">
        <mat-label>Additional Pickup Fee</mat-label>
        <input matInput type="text" formControlName="extraPickup" placeholder="Enter Additional Pickup Fee"
          (input)="roundOff($event, 9999, 4, 0, 'extraPickup')">
      </mat-form-field>
    </div>    

    <div [ngClass]="isWalmartGenerator ? 'form-grid-row cols-3' : 'form-grid-row cols-4'">
      <!-- EIS (%)  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('eis')">
        <mat-label>EIS(%)</mat-label>
        <input matInput type="text" class="field-with-error" formControlName="eis" placeholder="Enter EIS"
          (input)="roundOff($event, 100, 1, 0, 'eis')">
        <mat-error *ngIf="totePmForm.get('eis')?.hasError('max')">
          Value cannot be greater than 100.
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('fuelSurcharge')">
        <mat-label>Fuel Surcharge(%)</mat-label>
        <input matInput type="text" class="field-with-error" formControlName="fuelSurcharge"
          placeholder="Enter Fuel Surcharge" (input)="roundOff($event, 100, 1, 0, 'fuelSurcharge')">
        <mat-error *ngIf="totePmForm.get('fuelSurcharge')?.hasError('max')">
          Value cannot be greater than 100.
        </mat-error>
      </mat-form-field>

      <!-- Lock Install/Replace before and after  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('lockBeforeDelivery')">
        <mat-label>{{ isWalmartGenerator ? 'New Lock Fee' : 'Lock Install/Replace before' }}</mat-label>
        <input matInput type="text" formControlName="lockBeforeDelivery" placeholder="Enter Before Delivery Fee"
          (input)="roundOff($event, 99999, 4, 0, 'lockBeforeDelivery')">
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('lockAfterDelivery')">
        <mat-label>Lock Install/Replace After</mat-label>
        <input matInput type="text" formControlName="lockAfterDelivery" placeholder="Enter After Delivery Fee"
          (input)="roundOff($event, 99999, 4, 0, 'lockAfterDelivery')">
      </mat-form-field>

      <!-- additional pickup fee on site Fee  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('AdditionalPickupFeeForSite')">
        <mat-label>Additional Pickup Fee at Site</mat-label>
        <input matInput type="text" formControlName="additionalPickupFeeForSite"
          placeholder="Enter Additional Pickup Fee On Site"
          (input)="roundOff($event, 99999, 4, 0, 'additionalPickupFeeForSite')">
      </mat-form-field>

    </div>

    <div class="form-grid-row">
      <!-- Removal/Redelivery Fee (Dumpster Delivery Fee) & Relocation Fee  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('removalRedeliveryFee')">
        <mat-label>{{ isWalmartGenerator ? 'Dumpster Delivery Fee' : 'Removal/Redelivery Fee' }}</mat-label>
        <input matInput type="text" formControlName="removalRedeliveryFee" placeholder="Enter Delivery Fee"
          (input)="roundOff($event, 99999, 4, 0, 'removalRedeliveryFee')">
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('relocationFee')">
        <mat-label>Relocation Fee</mat-label>
        <input matInput type="text" formControlName="relocationFee" placeholder="Enter Relocation Fee"
          (input)="roundOff($event, 99999, 4, 0, 'relocationFee')">
      </mat-form-field>

      <!-- Dumpster Replacement Fee (Tote Replacement) & Startup fee  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('toteReplacement')">
        <mat-label>{{ isWalmartGenerator ? 'Dumpster Replacement Fee' : 'Tote Replacement' }}</mat-label>
        <input matInput type="text" formControlName="toteReplacement" placeholder="Enter Replacement Fee"
          (input)="roundOff($event, 99999, 4, 0, 'toteReplacement')">
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('startupFee')">
        <mat-label>Startup Fee</mat-label>
        <input matInput type="text" formControlName="startupFee" placeholder="Enter Startup Fee"
          (input)="roundOff($event, 99999, 4, 0, 'startupFee')">
      </mat-form-field>

    </div>

    <div class="form-grid-row">
      <!-- Per Pickup Fee  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('perPickupFee')">
        <mat-label>Per Pickup Fee</mat-label>
        <input matInput type="text" formControlName="perPickupFee" placeholder="Enter Per Pickup Fee"
          (input)="roundOff($event, 99999, 4, 0, 'perPickupFee')">
      </mat-form-field>

      <!-- Contamination Fee  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('contaminationFee')">
        <mat-label>Contamination Fee</mat-label>
        <input matInput type="text" formControlName="contaminationFee" placeholder="Enter Contamination fee"
          (input)="roundOff($event, 99999, 4, 0, 'contaminationFee')">
      </mat-form-field>

      <!-- Emergency Pickup Fee  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('emergencyPickupFee')">
        <mat-label>Emergency Pickup Fee</mat-label>
        <input matInput type="text" formControlName="emergencyPickupFee" placeholder="Enter Emergency Pickup fee"
          (input)="roundOff($event, 99999, 4, 0, 'emergencyPickupFee')">
      </mat-form-field>

      <!-- Leaking Bin  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('leakingBin')">
        <mat-label>Leaking Bin</mat-label>
        <input matInput type="text" formControlName="leakingBin" placeholder="Enter Leaking Bin"
          (input)="roundOff($event, 99999, 4, 0, 'leakingBin')">
      </mat-form-field>

    </div>

    <div class="form-grid-row">
      <!-- Damaged Bin  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('damagedBin')">
        <mat-label>Damaged Bin</mat-label>
        <input matInput type="text" formControlName="damagedBin" placeholder="Enter Damaged Bin"
          (input)="roundOff($event, 99999, 4, 0, 'damagedBin')">
      </mat-form-field>

      <!-- Land Fill Haul  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('landfillHaul')">
        <mat-label>Land Fill Haul</mat-label>
        <input matInput type="text" formControlName="landfillHaul" placeholder="Enter Land Fill Haul"
          (input)="roundOff($event, 99999, 4, 0, 'landfillHaul')">
      </mat-form-field>

      <!-- New Key Fee  -->
      <mat-form-field appearance="outline" *ngIf="isFieldVisible('newKey')">
        <mat-label>New Key Fee</mat-label>
        <input matInput type="text" formControlName="newKey" placeholder="Enter New Key Fee"
          (input)="roundOff($event, 99999, 4, 0, 'newKey')">
      </mat-form-field>
    </div>

    <!-- Rental Type Grid Section -->
    <div class="add-renttype-button-container">
      <button mat-raised-button color="primary" (click)="addorEditRentalType(null, true)" type="button">
        <mat-icon>add</mat-icon> Add Rental Type
      </button>
    </div>
    <div class="gridheight mat-elevation-z8 viewport">
      <table mat-table [dataSource]="rentalDataSource" formArrayName="rentalTypes" class="mat-elevation-z8"
        multiTemplateDataRows>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions</th>
          <td mat-cell *matCellDef="let row">
            <div>
              <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit"
                (click)="addorEditRentalType(row, false)" [disabled]="row.id === 0">
                <mat-icon>edit</mat-icon>
              </button>
              @if(showDeleteRentalType){
                <button mat-icon-button type="button" color="warn" title="Delete" (click)="deleteRentalType(row)"
                  style="color: red;">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="rentalTypeName">
          <th mat-header-cell *matHeaderCellDef> Rental Type </th>
          <td mat-cell *matCellDef="let element"> {{element.rentalTypeName}} </td>
        </ng-container>
        <ng-container matColumnDef="fee">
          <th mat-header-cell *matHeaderCellDef> Fee </th>
          <td mat-cell *matCellDef="let element"> {{element.fee}} </td>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef> Quantity </th>
          <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
        </ng-container>
        <ng-container matColumnDef="rentalSize">
          <th mat-header-cell *matHeaderCellDef> Size </th>
          <td mat-cell *matCellDef="let element"> {{element.rentalSize}} </td>
        </ng-container>
        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef> Start Date </th>
          <td mat-cell *matCellDef="let element"> {{element.startDate | date : "MM/dd/yyyy"}} </td>
        </ng-container>
        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef> End Date </th>
          <td mat-cell *matCellDef="let element"> {{element.endDate | date : "MM/dd/yyyy"}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="rentalDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: rentalDisplayedColumns;"></tr>

        <!-- Row shown when there is no data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center p-4 italic text-gray-500" [attr.colspan]="rentalDisplayedColumns.length"
            style="color: red;text-align: center;font-weight: 500;">
            No Rental Types.
          </td>
        </tr>
      </table>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" (click)="onCancel()">Cancel</button>
  @if(canSave){
    <button mat-raised-button color="primary" (click)="onSave()">Save</button>
  }
</mat-dialog-actions>
